{
	"no-face-detected": "No se detectó ninguna cara",
	"try-a-different-image": "Prueba con una imagen diferente"
}
